/**
 * URLs for legal documents (served from public/).
 * Use for footer links, signup disclaimer, and login disclaimer.
 */
const PUBLIC_URL = process.env.PUBLIC_URL || '';
export const PRIVACY_POLICY_URL = `${PUBLIC_URL}/privacy`;
export const TERMS_OF_SERVICE_URL = `${PUBLIC_URL}/terms`;
